/**
 * @description 版本配置
 **/
// 区分系统版本标志  1：单机版 2：分布式
export const platformType = parseInt(PLATFORM_ID);

// 区分系统标志 0：产教 1：出入 2：学工 3：迎新 5：一网通办 6：通用公寓（医科大） 7：师范公寓 8：招生 9.继续教育
export const sysPlatformType = "9";

// 系统标志 0：cjrh 1：crwf 2：xg 3：yx 5：ywtb 6：gy 7：sfgy 8：zs 9.jxjy
export const sysPlatformOs = "jxjy";

// 区分高校标志： 0: 岩石通版 1：河工大定制版 2：轻工学工 3：天职师大 4：医科大 5.继续教育
export const campusType = 5;
const campusEditions = [
  {
    name: "岩石大学",
    loginBg: require("@/assets/images/login/bg.png"),
    logo: require("@/assets/images/login/logo.png"),
  },
];
export const platform = {
  title: "继续教育学习（培训）录入系统",
  fullTitle: "继续教育学习（培训）录入系统",
  titleLogo: require("@/assets/images/logo_title_jxjy.png"),
};
// export const campus = campusEditions[campusType];
export const campus = campusEditions[0];
